import { useMemo } from "react";
import {
  InternalAdminUserListInput,
  InternalAdminUserListQuery,
  InternalAdminUserListQueryVariables,
} from "gql/graphql";
import { useQuery } from "@apollo/client";
import INTERNAL_ADMIN_USER_LIST_QUERY from "../_networking/internal-admin-user-list";

interface IProps {
  organizationId?: string;
  input: InternalAdminUserListInput;
}

const useInternalAdminUserList = ({ organizationId, input }: IProps) => {
  const { data, loading } = useQuery<
    InternalAdminUserListQuery,
    InternalAdminUserListQueryVariables
  >(INTERNAL_ADMIN_USER_LIST_QUERY, {
    fetchPolicy: "network-only",
    variables: organizationId
      ? {
          organizationId,
          input,
        }
      : undefined,
    skip: !organizationId,
  });

  const users = useMemo(() => {
    if (!data) return [];
    return data.internalAdminUserList;
  }, [data]);

  return {
    users,
    loading,
  };
};

export default useInternalAdminUserList;
